import WatsonAssistant from './watson';

const watsonAssistant = (() => {
    let watsonInstance = null;

    return {
        setInstance(instance) {
            watsonInstance = new WatsonAssistant(instance);
            watsonInstance.attachListeners();
        },
        getInstance() {
            if (!watsonInstance) {
                throw new Error('Watson Assistant has not been initialsed');
            }
            return watsonInstance;
        },
    };
})();

export default watsonAssistant;